// material-ui
import { Grid2 as Grid, Stack, Typography } from '@mui/material'

import RequirePasswordChangeForm from 'sections/auth/auth-forms/RequirePasswordChangeForm'
// project import
import AuthWrapper from 'sections/auth/AuthWrapper'

// ================================|| REQUIRE PASSWORD CHANGE ||================================ //

function RequirePasswordChange() {
  return (
    <AuthWrapper>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Stack sx={{ mb: { xs: -0.5, sm: 0.5 } }} spacing={1}>
            <Typography variant="h3">Password Change Required</Typography>
            <Typography>For security reasons, you must change your password before continuing</Typography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <RequirePasswordChangeForm />
        </Grid>
      </Grid>
    </AuthWrapper>
  )
}

export default RequirePasswordChange
